import { BannerType } from "types/models";

export const isFloatingBanner = (bannerType: string | undefined) =>
  bannerType === BannerType.FLOATING;
